import { render, staticRenderFns } from "./check-box.vue?vue&type=template&id=671a9af2&scoped=true&"
import script from "./check-box.vue?vue&type=script&lang=js&"
export * from "./check-box.vue?vue&type=script&lang=js&"
import style0 from "./check-box.vue?vue&type=style&index=0&id=671a9af2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671a9af2",
  null
  
)

component.options.__file = "check-box.vue"
export default component.exports